import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { FeatureFlag } from '@app/core/services/feature-flags/feature-flag.model';
import { FeatureFlagService } from '@app/core/services/feature-flags/feature-flag.service';
import { catchError, first, map, Observable, of, timeout } from 'rxjs';

const FLAGS_TIMEOUT_MS = 5000;

@Injectable({
  providedIn: 'root',
})
export class SmartCartEnabledGuard {
  constructor(
    private router: Router,
    private featureFlags: FeatureFlagService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.featureFlags.isEnabled$(FeatureFlag.SmartCart).pipe(
      first(),
      timeout(FLAGS_TIMEOUT_MS),
      map((enabled) => (enabled ? true : this.router.parseUrl(''))),
      catchError(() => of(this.router.parseUrl(''))),
    );
  }
}
